import { useEffect, useState } from "react";

const dataStatus = "data-status";

const getEventType = (event) => (event.type === "load" ? "ready" : "error");

const setAttributeFromEvent = (script) => (event) => {
	script.setAttribute(dataStatus, getEventType(event));
};

const useScript = (src, position, defer = false) => {
	const [status, setStatus] = useState(src ? "loading" : "idle");

	useEffect(() => {
		if (!src) {
			setStatus("idle");
			return;
		}

		let script = document?.querySelector(`script[src="${src}"]`);

		if (!script) {
			script = document?.createElement("script");
			script.src = src;
			if (defer) {
				script.defer = true;
				script.removeAttribute("async");
			} else {
				script.async = true;
				script.removeAttribute("defer");
			}
			script.setAttribute(dataStatus, "loading");
			if (position) {
				document[position].appendChild(script);
			}
			script.addEventListener("load", setAttributeFromEvent(script));
			script.addEventListener("error", setAttributeFromEvent(script));
		} else {
			setStatus(script.getAttribute(dataStatus));
		}

		const setStateFromEvent = (event) => {
			setStatus(getEventType(event));
		};

		script.addEventListener("load", setStateFromEvent);
		script.addEventListener("error", setStateFromEvent);

		// Remove event listeners on cleanup
		return () => {
			if (script) {
				script.removeEventListener("load", setStateFromEvent);
				script.removeEventListener("error", setStateFromEvent);
			}
		};
	}, [src, position, defer]);

	return status;
};

export default useScript;
